// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"245d0b12","453":"5702a144","480":"c1a3ba1d","500":"c96561dd","746":"98bf521d","929":"fd68b2a2","992":"1b924334"}[chunkId] + ".chunk.js";
};